export default {
  init() {
    var nameWrapper = document.querySelector('.input-name');
    var category;
    var lStorage = JSON.parse(JSON.stringify(localStorage));

    if (document.querySelector('.shop__content')) {
      category = document.querySelector('.shop__content').getAttribute('data-category');
    }
    var nameSetted = localStorage.getItem('category__' + category);
    var namesSaved = document.querySelector('.names__saved');
    const ajaxurl = window.ajaxurl;

    var cards = document.querySelectorAll('.shop__item--card');

    if (nameWrapper) {
      var submit = nameWrapper.querySelector('.add-name');
      var name = nameWrapper.querySelector('.input');
      var nameValue;
      var categoryName = nameWrapper.querySelector('.category--name');
      var edit = nameWrapper.querySelector('.category--name .edit');
      var names = [];

      if (nameSetted && nameSetted !== null) {
        categoryName.querySelector('.name').innerText = nameSetted;
        submit.classList.add('hidden');
        name.classList.add('hidden');
        categoryName.classList.add('visible');
      } else {
        Object.entries(lStorage).forEach(([key, value]) => {
          if(key.includes('category')) {
            names.push(value);
          }
        });

        if (namesSaved.classList.contains('hidden')) {
          namesSaved.classList.remove('hidden')
        }
        
        names = Array.from(new Set(names));

        for (let index = 0; index < names.length; index++) {
          var item = document.createElement('span');

          item.classList.add('name-item');
          item.innerText = names[index];
          namesSaved.appendChild(item);
          
        }
        
        namesSaved.querySelectorAll('.name-item').forEach(nameSaved => {
          nameSaved.addEventListener('click', () => {
            name.value = nameSaved.innerText;
            namesSaved.classList.add('hidden');
            submit.click();
          })
        });
      }
      
      submit.addEventListener('click', () => {
        nameValue = name.value;
        if(nameValue !== '') {
          
          categoryName.querySelector('.name').innerText = nameValue;
          submit.classList.add('hidden');
          name.classList.add('hidden');
          categoryName.classList.add('visible');

          localStorage.setItem('category__' + category, nameValue);

          if (!nameWrapper.querySelector('.message--alert').classList.contains('hidden')) {
            nameWrapper.querySelector('.message--alert').classList.add('hidden');
          }
        } else {
          nameWrapper.querySelector('.message--alert').classList.remove('hidden');
        }
      })

      edit.addEventListener('click', () => {
        categoryName.querySelector('.name').innerText = '';
        submit.classList.remove('hidden');
        name.classList.remove('hidden');
        categoryName.classList.remove('visible');
        localStorage.removeItem('category__' + category);
      })
    }

    if(cards.length > 0) {

      cards.forEach(card => {
        var quantity = card.querySelector('.quantity .qty');
        var minus = card.querySelector('.qty--minus');
        var plus = card.querySelector('.qty--plus');
        var btn = card.querySelector('.add-product');
        var btnDetail = card.querySelector('.product--detailed');

        if(btn){
          var product_id = btn.getAttribute('data-id');
          var xhr = new XMLHttpRequest();
          var formData = new FormData();
    
          plus.addEventListener('click', function () {
            var oldValue = quantity.value;
            var newVal = parseFloat(oldValue) + 1;
    
            quantity.value = newVal;
    
          })
    
          minus.addEventListener('click', function () {
            var oldValue = quantity.value;
            var newVal;
            
            if (oldValue > 0) {
              newVal = parseFloat(oldValue) - 1;
            } else {
              newVal = 0;
            }
            quantity.value = newVal;
    
          })
    
          btn.addEventListener('click', function() {
            nameValue = name.value;
            nameSetted = localStorage.getItem('category__' + category);
    
            if (nameSetted == null) {
              nameWrapper.querySelector('.message--alert').classList.remove('hidden');
              window.scrollTo(0, document.querySelector('.input-name').offsetTop - 180);
            } else {
              formData.append("action", 'woocommerce_ajax_add_to_cart');
              formData.append("product_id", product_id);
              formData.append("product_sku", '');
              formData.append("quantity", quantity.value);
              formData.append("order_item_status", "nuevo_pedido");
              if(nameSetted) {
                formData.append("order_item_name", nameSetted);
              }
              xhr.open("POST", ajaxurl);
              xhr.send(formData);
    
              cards.forEach(card => {
                card.classList.toggle('loading');
              });
      
              xhr.onloadend = () => {
                if (xhr.status == 200) {
                  // var response = xhr.response;
      
                  window.refreshCart(false, false);
                  cards.forEach(card => {
                    card.classList.toggle('loading');
                  });
                }
              }
            }
          })

          if(btnDetail) {
            btnDetail.addEventListener('click', function (e) {
              nameValue = name.value;
              nameSetted = localStorage.getItem('category__' + category);
  
              if (nameSetted == null) {
                nameWrapper.querySelector('.message--alert').classList.remove('hidden');
                window.scrollTo(0, document.querySelector('.input-name').offsetTop - 180);
                e.preventDefault();
                e.stopPropagation();
              }
            })
          }
        }
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/taxonomy-data.js